<nav class="main-menu">

  <ng-container #navigationComponentPlaceholder></ng-container>
  <ng-container #filtersComponentPlaceholder></ng-container>

  <div #modalContainer></div>
</nav>
